module.exports = __webpack_public_path__ + "media/assets/images/login_kousaku_logo-a9604d03e8765e113bcf643136ce0bfc.png";